// extracted by mini-css-extract-plugin
export default {"root":"Study_root__ocUjP","content":"Study_content__tDGpR","footer":"Study_footer__NUOSq"};